"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useComboboxContextValues", {
    enumerable: true,
    get: function() {
        return useComboboxContextValues;
    }
});
function useComboboxContextValues(state) {
    const { activeOption, appearance, focusVisible, open, registerOption, selectedOptions, selectOption, setActiveOption, setOpen, size } = state;
    const combobox = {
        activeOption,
        appearance,
        focusVisible,
        open,
        registerOption,
        selectedOptions,
        selectOption,
        setActiveOption,
        setOpen,
        size
    };
    return {
        combobox
    };
}
